import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOIps } from "../models/BOIps.model";

@Injectable()
export class IpsService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/Ips';

    constructor(private http:HttpClient){}

    getAll():Observable<BOIps[]>{        
        return this.http.get<BOIps[]>(this.myAppUrl + this.myApiUrl);
    }   
}